import React from 'react';
import { InformationCircleIcon, CloseIcon } from '@assets/icon';
import './GlobalToast.scss';

export interface ToastMessage {
  id?: string;
  text: string;
  type: 'success' | 'error' | 'info' | 'cskh';
  actionLabel?: string;
  onAction?: () => void;
}

interface GlobalToastProps {
  message: ToastMessage | null;
  onClose: () => void;
}

const GlobalToast : React.FC<GlobalToastProps> = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div key={message.id} className={`global-toast toast-${message.type}`}>
      <div className="global-toast-content">
        {message.type === 'cskh' && <InformationCircleIcon className="toast-info-icon" />}
        
        <div className="toast-main-content">
            <span className="toast-text">{message.text}</span>
            {message.type === 'cskh' && message.onAction && (
              <button 
                className="toast-action-btn" 
                onClick={message.onAction}
                type="button"
              >
                {message.actionLabel || 'Xem chi tiết'}
              </button>
            )}
        </div>

        <div className="toast-divider" />
        
        <button
          className="global-toast-close"
          onClick={onClose}
          type="button"
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
};

export default GlobalToast;
